import { render, staticRenderFns } from "./knowledgeVisualization.vue?vue&type=template&id=be67bb20&scoped=true"
import script from "./knowledgeVisualization.vue?vue&type=script&lang=js"
export * from "./knowledgeVisualization.vue?vue&type=script&lang=js"
import style0 from "./knowledgeVisualization.vue?vue&type=style&index=0&id=be67bb20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be67bb20",
  null
  
)

export default component.exports